
  <printheaderview [hasimage]="1"
                   [OwnerName]="Owner"
                   [FormattedCode]="FormattedCode"
                   [Protocolst]="Protocolst"
                   [ProtocolEd]="ProtocolEd"
                   [Protocol]="Protocol"
                   [Infertility]="Infertility"
                   [Gender]="Gender"
                   [Age]="Age"
                   [CycleNo]="CycleNo">
  </printheaderview>
  <div class="row">
    <div class="col-md-12">
      <div class="card">

        <div class="card-body padding-top-0px padding-bottom-0px">

          <div class="row">
            <div class="col-md-12 text-align-center">
              <label class="margin-bottom-0px f4">Follicular Scan Summary</label>
            </div>
          </div>
          <div class="table-component margin-bottom-0px">
            <div class="table-responsive overflow-x-hidden">

              <table class="table table-striped margin-left-zero">

                <thead class="">
                  <tr>

                    <th class="">Doc&Date</th>

                    <th class="">Endo Thickness</th>

                    <th class="">Medicines & Tests</th>
                    <th class="">Ovaries</th>
                    <th class="">Comments</th>
                  </tr>
                </thead>
                <tbody class="table-body">
                  <tr>
                    <td>{{Doc}}<br />{{DocDate | date:'dd-MMM-yyyy'}}</td>
                    <td>{{EndometriumThickness}}</td>

                    <td class="">

                      Medicines:{{MedicineName}} <br />
                      Tests:{{TestName}} <br />


                    </td>

                    <td class="">

                      Left: {{LeftOvaries}}<br />
                      Right:{{RightOvaries}}


                    </td>
                    <td></td>


                  </tr>

                </tbody>

              </table>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
  <printfooterview></printfooterview>


